/**
 * #278 item 4: the TLS choices of a SQL Server catalog crawl, shared by the
 * two crawl forms (Connectors, Scans). The controller encrypts by default and
 * verifies the server's certificate unless told to trust it
 * (catalog-crawler.ts mssqlTlsOptions); before this the forms could not say
 * either, so a lab server with a self-signed certificate could not be crawled
 * at all, and a production one could not be told to verify.
 */
export interface CrawlTls {
  encrypt: boolean;
  trustServerCertificate: boolean;
}

export const DEFAULT_CRAWL_TLS: CrawlTls = { encrypt: true, trustServerCertificate: false };

/** The connection fields a crawl sends for these choices (SQL Server only). */
export function crawlTlsConnection(vendor: string, tls: CrawlTls): { ssl?: boolean; trustServerCertificate?: boolean } {
  if (vendor !== 'mssql') return {};
  return { ssl: tls.encrypt, trustServerCertificate: tls.encrypt && tls.trustServerCertificate };
}

export function CrawlTlsFields({
  vendor,
  tls,
  onChange,
}: {
  vendor: string;
  tls: CrawlTls;
  onChange: (tls: CrawlTls) => void;
}) {
  if (vendor !== 'mssql') return null;
  return (
    <div className="space-y-1 text-xs text-muted-foreground" data-testid="crawl-tls-fields">
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          aria-label="Encrypt the connection (TLS)"
          checked={tls.encrypt}
          onChange={(e) => onChange({ ...tls, encrypt: e.target.checked })}
        />
        Encrypt the connection (TLS). Off sends the login and every sampled value in clear text.
      </label>
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          aria-label="Trust the server certificate"
          checked={tls.trustServerCertificate}
          disabled={!tls.encrypt}
          onChange={(e) => onChange({ ...tls, trustServerCertificate: e.target.checked })}
        />
        Trust the server certificate without verifying it (lab or development servers only).
      </label>
    </div>
  );
}
